<template>
  <b-modal
    v-model="isVisible"
    :hide-footer="true"
    :hide-header="true"
    centered
    no-close-on-backdrop
    @hidden="onModalHidden"
  >
    <b-row>
      <b-col
        cols="12"
        class="d-flex justify-content-between mb-2 mt-2"
      >
        {{ $t('otp-description', { type: twoFactorTypeLabel }) }}
        <b-button
          variant="link"
          class="p-0"
          style="font-size: 1.8rem; line-height: 1;"
          aria-label="Close"
          @click="isVisible = false"
        >
          <span
            style=""
            aria-hidden="true"
          >&times;</span>
        </b-button>
      </b-col>
    </b-row>
    <b-col cols="12">
      <validation-observer
        ref="verifyForm"
      >
        <form
          ref=""
          @submit.stop.prevent="handleOTP"
        >
          <b-form-group
            invalid-feedback="Verification code is required"
            label-for="verification_code"
            :label="$t('verification_code')"
          >
            <div id="divOuter">
              <div id="divInner">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('verification_code')"
                  vid="verification-code"
                  rules="required"
                >
                  <b-form-input
                    id="partitioned"
                    v-model="verifyCode"
                    maxlength="6"
                    oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                    on-key-press="if(this.value.length==4) return false;"
                    required
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>
            </div>
          </b-form-group>
          <b-row>
            <b-col
              cols="12"
              class="my-1"
            >
              <CountdownTimer :remaining-time="remainedTime" />
            </b-col>
            <b-col class="text-center mb-2">
              <span>
                {{ $t("did-not-receive-code?") }}
                <span
                  v-if="!pendingReSendOtp"
                  class="text-primary text-decoration-underline cursor-pointer"
                  @click="resendOTP"
                > {{ $t('resend-code') }}
                </span>
                <span v-else>
                  <b-spinner
                    small
                    type="grow"
                  />
                </span>
              </span></b-col>
          </b-row>
          <b-row align-h="between">
            <b-col
              cols="12"
              class="d-flex justify-content-center"
            >
              <b-button
                variant="primary"
                :disabled="verifyCode.length < 4"
                pill
                class="w-50 mb-2"
                @click="handleOTP"
              >
                <span v-if="!pendingOtp">{{ $t('activate') }}</span>
                <span v-else>
                  <b-spinner
                    small
                    type="grow"
                  />
                </span>
              </b-button>
            </b-col>
            <!-- <b-col cols="auto">
              <b-button
                variant="primary"
                :disabled="!reSendBtn"
                @click="resendOTP"
              >
                <span v-if="!pendingReSendOtp">{{ $t('re-send') }}</span>
                <span v-else>
                  <b-spinner
                    small
                    type="grow"
                  />
                </span>
              </b-button>
            </b-col> -->
          </b-row>
        </form>
      </validation-observer>
    </b-col>
  </b-modal>
</template>

<script>
import OtpVerificationModalLogic from '@/views/logics/components/OtpVerificationModal'
import CountdownTimer from './CountdownTimer.vue'

export default {
  name: 'OtpVerificationModal',
  components: {
    CountdownTimer,
  },

  mixins: [OtpVerificationModalLogic],

}
</script>
